/** @jsx jsx */
import { jsx } from "theme-ui"
import { memo } from "react"
import Spinner from "react-spinkit"

const Loader = memo(() => <Spinner sx={{ mt: 5 }} name="ball-spin-fade-loader" color="blue" />)

export default Loader
